import { Alert, Box, Text } from 'braid-design-system';
import React from 'react';

import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';

import {
  Validation,
  useCreateResumeErrorMessage,
} from '../Validation/Validation';
import type { CreateResumeRoute } from '../types';

interface Props {
  name: CreateResumeRoute;
}

export const CardError = ({ name }: Props) => {
  const page = useTypedSelector(({ createResume }) => createResume.pages[name]);
  const isTouched = page?.touched;
  const tone = isTouched ? 'caution' : 'info';
  const errorMessage = useCreateResumeErrorMessage()[name];

  return (
    <Validation name={name} renderOnInvalid={true}>
      <Box marginTop="medium" data-automation={`${name}-card-error-${tone}`}>
        <Alert tone={tone}>
          <Text>{errorMessage}</Text>
        </Alert>
      </Box>
    </Validation>
  );
};
